import React from 'react';

import block from 'propmods';

import { routes } from '../../lib/routes';
import Link from '../Link/Link';

import { DocumentationTypo } from './DocumentationTypo';

import './DocumentationMenu.scss';

const b = block('DocumentationMenu');

const { DocPage, H1 } = DocumentationTypo;

interface Props {
    displayIntents: boolean;
    displayState: boolean;
    displayAppmetrica: boolean;
}

const DocumentationMenuBlock: React.FC<Props> = ({ displayAppmetrica, displayIntents, displayState }) => {
    return (
        <div {...b()}>
            <H1>Документация</H1>
            <ul {...b('list')}>
                {displayIntents && (
                    <li>
                        <Link to={routes.app.documentation('nlu')}>
                            <div {...b('link')}>Обработка естественного языка (NLP)</div>
                        </Link>
                    </li>
                )}
                {displayState && (
                    <li>
                        <Link to={routes.app.documentation('state')}>
                            <div {...b('link')}>Хранение состояния</div>
                        </Link>
                    </li>
                )}
                {displayAppmetrica && (
                    <li>
                        <Link to={routes.app.documentation('appmetrica')}>
                            <div {...b('link')}>AppMetrica</div>
                        </Link>
                    </li>
                )}
            </ul>
        </div>
    );
};

export const DocumentationMenu: React.FC<Props> = (props) => {
    return (
        <DocPage>
            <DocumentationMenuBlock {...props} />
        </DocPage>
    );
};
